

require('./bootstrap');
require('slick-carousel/slick/slick.min');
require('./fancybox.umd');
require('./jquery.maskedinput.min');

import $ from "jquery";

import { createApp } from 'vue';
import SubwaysFilterComponent from './components/SubwaysFilterComponent';
import YandexMapComponent from './components/YandexMapComponent';
import EventLeadForm from "./components/EventLeadForm";
import EventPromoCodes from './components/EventPromoCodes';
import PartnersForm from './components/PartnersForm';

const app = createApp({});
app.component('yandex-map-component', YandexMapComponent);
app.component('subways-filter-component', SubwaysFilterComponent);
app.component('event-promo-codes', EventPromoCodes);
app.component('partners-form', PartnersForm);
app.component('event-lead-form', EventLeadForm);

app.mount('#app');

$(document).ready(function () {
    $(document).on('click', '.b-catalog__filter-button input', function() {
        var lev1 = $(this).attr('level1');
        var lev2 = $(this).attr('level2');
        var lev3 = $(this).attr('level3');
        var params = {};
        if (lev1 && lev2 && lev3){
            params[lev1] = {};
            params[lev1][lev2] = lev3
        } else {
            params[lev1] = lev3
        }
        console.log(params);
        ym(93668485,'reachGoal','filter',params);
    })

    if (localStorage.getItem("age18") !== null) {
        $('.w-age-verification').remove();
    }

    $('.age18Approve').click(function(){
        localStorage.setItem('age18', 'true')
        $('.w-age-verification').remove();
    });

    $('.age18Decline').click(function(){
        history.back()
    });

    $(document).on('click', '.ajax-events-link, .ajax-events-links > li > a', function() {
        const href = $(this).attr('href')
        let action = href

        if(!action.includes('/ajax')) {
            action = action.replace('/catalog', '/catalog/ajax')
        }

        $('#ajax-events-container').addClass('gid-loader');

        $.get(action, function( data ) {
            history.pushState({ url: href }, '', href);

            $('#ajax-events-container').html( data );
            $('#ajax-events-container').removeClass('gid-loader');
            catalog();
        });

        return false;
    });

    function ajaxFilters() {
        const form = $('.ajax-events-form');

        $('#ajax-events-container').addClass('gid-loader');

        let action = form.attr('action')

        if(!action.includes('/ajax')) {
            action = action.replace('/catalog', '/catalog/ajax')
        }

        $.ajax({
            type: "GET",
            url: action,
            data: form.serializeArray(),
            dataType: "html",
        }).done(function (data) {
            let fullURL = form.attr('action') + '?' + $.param(form.serializeArray());

            history.pushState({ url: fullURL }, '', fullURL);

            $('#ajax-events-container').html( data );
            $('#ajax-events-container').removeClass('gid-loader');
            catalog();
        });
    }

    $(document).on('change', '.ajax-events-form', function() {
        ajaxFilters();

        return false;
    });

    $(document).on('submit', '.ajax-events-form', function() {
        ajaxFilters();

        return false;
    });

    $('.showul').click(function() {
        $(this).parent().children('ul').slideToggle()
    })
    $('.showul').click();

    $('.w-header__categories-hasSubmenu > a span.trigger-open').click(function () {
        $(this).parent().toggleClass('state-active');
        $(this).parent().parent().find('ul.w-header__subCategories').slideToggle('fast');
        return false;
    });

    $('.w-header__menuToggle-close, .w-header__menuOverlay').click(function () {
        $('.w-header__menuToggle').removeClass('state-open');
        $('.w-header__menuOverlay').hide();
        $('.w-header__menuToggle-content').hide();
    });

    function catalog() {
        calendar()

        $('.js-has-dropdown-link').click(function () {
            $(this).toggleClass('state-active');
            $(this).parent().find('.js-has-dropdown').toggleClass('state-open');
        });

        $('.b-catalog__menuToggle-close').click(function () {
            $('.b-catalog__filter-dropdown, .b-catalog__sorter-dropdown').removeClass('state-open');
        });

        $('.js-catalog__map-link-desktop').click(function () {
            $('.b-catalog__head-left.__desktop').toggle();
            $('.b-catalog__map').toggle();
            $('.b-catalog__events').toggle();
            $(this).text($(this).text() == 'Закрыть карту' ? 'Показать на карте' : 'Закрыть карту');
        });

        $('.js-catalog__map-link-mobile').click(function () {
            $('.b-catalog__map').toggle();
            $('.b-catalog__events').toggle();
            $(this).text($(this).text() == 'Закрыть карту' ? 'Показать на карте' : 'Закрыть карту');
        });

        $('.js-button-open-filters').click(function () {
            $('.js-catalog-sidebar').addClass('state-open');
            return false;
        });

        $('.b-catalog__sidebar-close').click(function () {
            $('.js-catalog-sidebar').removeClass('state-open');
            return false;
        });
    }

    function calendar() {
        $('.b-calendar__slider').slick({
            speed: 200,
            slidesToScroll: 7,
            variableWidth: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1214,
                    settings: {
                        arrows: false,
                        swipeToSlide: true
                    }
                }
            ]
        });
    }

    catalog();

    $('.main-slider__inner').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    });

    $('.b-sliderStandart-popular').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.popular-arrow-next',
        prevArrow: '.popular-arrow-prev'
    });

    $('.b-sliderStandart-new').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.new-arrow-next',
        prevArrow: '.new-arrow-prev'
    });

    $('.b-sliderStandart-theatre').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.theatre-arrow-next',
        prevArrow: '.theatre-arrow-prev'
    });

    $('.b-sliderStandart-entertainment').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.entertainment-arrow-next',
        prevArrow: '.entertainment-arrow-prev'
    });

    $('.b-sliderStandart-watched').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.watched-arrow-next',
        prevArrow: '.watched-arrow-prev'
    });

    $('.b-sliderStandart-river').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.river-arrow-next',
        prevArrow: '.river-arrow-prev'
    });

    $('.b-sliderStandart-free').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.free-arrow-next',
        prevArrow: '.free-arrow-prev'
    });

    $('.b-sliderStandart-more').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        variableWidth: true,
        nextArrow: '.more-arrow-next',
        prevArrow: '.more-arrow-prev'
    });

    $('.main-section__partners-slider').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.main-section__collections-slider').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            }
        ]
    });

    $('.b-event__topSlider').slick({
        autoplay: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    dots: true
                }
            }
        ]
    });

    var desktop = !('ontouchstart' in document.documentElement);

    var minHeight = 182000, time = 250, offset = 50;
    $('.b-event__textBox').each(function (i) {
        if ($(this)[0].scrollHeight > minHeight) { $(this).after('<div class="b-event__readmore">Показать все</div>'); }
    });

    $(".b-event__readmore").click(function () {
        var textbox = $(this).prev('.b-event__textBox')
        if ($(this).text() == 'Показать все') {
            textbox.css('height', textbox[0].scrollHeight);
            $(this).text('Свернуть');
        } else {
            if (desktop) {
                textbox.css('height', minHeight);
                $('html, body').animate({ scrollTop: textbox.offset().top - offset }, { duration: time })
                .promise().then(function () { });
            } else {
                location.href = '#' + $(this).parent().attr('id');
                textbox.css('height', minHeight);
            }
            $(this).text('Показать все');
        }
    });

    var $status = $('.b-event__gallery-paging');
    var $slickElement = $('.b-event__gallery-slider-for');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + ' из ' + slick.slideCount);
    });

    $slickElement.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        slide: '.b-event__gallery-slider-for-item',
        asNavFor: '.b-event__gallery-slider-nav',
        autoplay: true,
        dots: true
    });

    $('.b-event__gallery-slider-nav').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true
    });

    $('.b-event__priceModal-close').click(function () {
        $('.b-event__priceModal').hide();
    });

    $('.b-faq__accordion > li:eq(0) a').addClass('active').next().slideDown();

    $('.b-faq__accordion a').click(function (j) {
        var dropDown = $(this).closest('li').find('p');

        $(this).closest('.b-faq__accordion').find('p').not(dropDown).slideUp();

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).closest('.b-faq__accordion').find('a.active').removeClass('active');
            $(this).addClass('active');
        }

        dropDown.stop(false, true).slideToggle();

        j.preventDefault();
    });

    $('.b-about__reviews-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            }
        ]
    });

    if ($('.main-section__categories-item').length > 6) {
        $('.main-section__categories-item:gt(5)').hide();
    }

    $('.main-section__categories-more-button').on('click', function () {
        $('.main-section__categories-item:gt(5)').toggle();
        $('.main-section__categories-more').hide();
    });

    $('.w-scrollTop').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, '300');
    });

    $('.w-modal__close').click(function () {
        $('.w-modal').hide();
    });

    $('.b-event__promocode-buttonBuy').click(function () {
        $('.b-modal__promocode').show();
    });

    $('.b-event__lead-form-buttonBuy').click(function () {
        $('.w-modal__lead').show();
    });

    $('.partnersModalTrigger').click(function () {
        $('.w-modal__partners').show();
    });

    $(".mask-phone").mask("+7 (999) 999-99-99");

    $('.mask-time').mask('00:00');

    $('.w-dropdown-slide__overlay, .w-dropdown-slide__close').click(function () {
        $('.js-has-dropdown-link').removeClass('state-active');
        $('.js-has-dropdown').removeClass('state-open');
        return false;
    });

    $('.nav-sticky__link-city').click(function () {
        $('.w-header__nav-city-dropdown').toggleClass('state-active');
        $('.w-header__nav-city-dropdown').toggleClass('state-open');
        return false;
    });

    if (window.location.hash) {
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top - 20
        }, 500);
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
        var closeHeight = '20em'; 
        var moreText 	= 'Подробнее...'; 
        var lessText	= 'Скрыть';
        var duration	= '1000';
        var easing = 'linear'; 
    
        $('.w-read-more').each(function() {
          
          var current = $(this).children('.w-read-more__content');
          current.data('fullHeight', current.height()).css('height', closeHeight);
    
          current.after('<a href="javascript:void(0);" class="more-link closed">' + moreText + '</a>');
    
        });
        
        var openSlider = function() {
          var link = $(this);
          var openHeight = link.prev('.w-read-more__content').data('fullHeight') + 'px';
          link.prev('.w-read-more__content').animate({'height': openHeight}, {duration: duration }, easing);
          link.text(lessText).addClass('open').removeClass('closed');
          link.unbind('click', openSlider);
          link.bind('click', closeSlider);
        }
    
        var closeSlider = function() {
          var link = $(this);
          link.prev('.w-read-more__content').animate({'height': closeHeight}, {duration: duration }, easing);
          link.text(moreText).addClass('closed').removeClass('open');
          link.unbind('click');
          link.bind('click', openSlider);
        }
        
        $('.more-link').bind('click', openSlider);
    }
});

const accordionBtns = document.querySelectorAll(".b-catalog__accordion-button");

accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
        this.classList.toggle("state-active");
        let content = this.nextElementSibling;
        content.classList.toggle("state-open");
    };
});

const popupTelegram = document.querySelector(".js-cookie-telegram");
const closeTelegram = document.querySelector(".js-close-telegram");

function showPopup() {
  popupTelegram.classList.add("show");
  popupTelegram.classList.remove("hide");
}

function hidePopup() {
  popupTelegram.classList.add("hide");
  popupTelegram.classList.remove("show");
}

function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

document.querySelector(".js-accept-telegram").addEventListener("click", () => {
  //localStorage.setItem("cookieAccepted", "1");
    let date = new Date(Date.now() + 30*86400e3);
    date = date.toUTCString();
    document.cookie = "cookieAccepted=1; expires=" + date+";path=/;domain=.gid365.ru";
    hidePopup();
});

if (getCookie("cookieAccepted") === "1") {
  hidePopup();
} else {
  if (getCookie('tgClosed')){
    let d = new Date(getCookie('tgClosed'));
    if (Date.now()<d.getTime()){
        hidePopup();
    } else {
        showPopup();
    }
  } else {
    showPopup();
  }
}

closeTelegram.onclick = function () {
    let date = new Date(Date.now() + 30*86400e3);
    date = date.toUTCString();
    document.cookie = "tgClosed="+date+"; expires=" + date+";path=/;domain=.gid365.ru";;
    hidePopup();
};

// active class of brand tabs onscroll
window.addEventListener('scroll', () => {
	let scrollDistance = window.scrollY;

    document.querySelectorAll('.section-anchor').forEach((el, i) => {
        if (el.offsetTop - document.querySelector('.b-brand__tabs').clientHeight <= scrollDistance) {
            document.querySelectorAll('.b-brand__tabs a').forEach((el) => {
                if (el.classList.contains('state-active')) {
                    el.classList.remove('state-active');
                }
            });

            document.querySelectorAll('.b-brand__tabs li')[i].querySelector('a').classList.add('state-active');
        }
    });
});